<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
    <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{message}}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-card class="neu-glow">
        <v-card-title primary-title>
        <div class="text-h5">{{$t(page+'.Fattura Elettronica')}} <span class="subtitle-1">({{$t(page+'.with red background')}})</span></div>
    </v-card-title>
    <v-container grid-list-xl fluid>
    <v-row v-if="selects">
        <v-col md="4" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.REAUfficio')"
            name="REAUfficio"
            v-model="form.REAUfficio"
            @blur="$v.form.REAUfficio.$touch()"
            @change="$parent.save($event, 'REAUfficio')"
            :items="selects.ProvinciaAlboItems"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'REAUfficio')"             
            background-color="#ff000010"
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            :label="$t(page+'.REANumero')"
            name="REANumero"
            v-model="form.REANumero"
            @blur="$v.form.REANumero.$touch()"
            filled
            outlined
            dense
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'REANumero')"  
            @input.native="$parent.save"
            background-color="#ff000010"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-dialog
            ref="READata_dialog"
            v-model="READata_modal"
            :return-value.sync="form.READata"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.READata"
                :label="$t(page+'.READata')"
                prepend-inner-icon="fas fa-calendar"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                filled
                name="READata"
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'READata')"  
                background-color="#ff000010"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="form.READata"
              scrollable
              :locale="user.locale"
              :first-day-of-week="user.fdow||1"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="READata_modal = false"
              >
                {{$t(page+'.Cancel')}}
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="READata_modal=false;$parent.save(form.READata, 'READata')"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.Company Type')"
            v-model="form.CompanyType"
            name="CompanyType"
            @change="$parent.save($event, 'CompanyType')"
            :items="selects.CompanyTypeItems"
            @blur="$v.form.CompanyType.$touch()"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'CompanyType')"              
            background-color="#ff000010"            
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.RegimeFiscale')"
            v-model="form.RegimeFiscale"
            name="RegimeFiscale"
            @change="$parent.save($event, 'RegimeFiscale')"
            :items="selects.RegimeFiscaleItems"
            @blur="$v.form.RegimeFiscale.$touch()"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'RegimeFiscale')"               
            background-color="#ff000010"            
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.SocioUnico')"
            v-model="form.SocioUnico"
            name="SocioUnico"
            @change="$parent.save($event, 'SocioUnico')"
            :items="selects.SocioUnicoItems"
            @blur="$v.form.SocioUnico.$touch()"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'SocioUnico')"               
            background-color="#ff000010"            
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.StatoLiquidazione')"
            v-model="form.StatoLiquidazione"
            name="StatoLiquidazione"
            @change="$parent.save($event, 'StatoLiquidazione')"
            :items="selects.StatoLiquidazioneItems"
            @blur="$v.form.StatoLiquidazione.$touch()"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'StatoLiquidazione')"   
            background-color="#ff000010"            
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.EsigibilitaIVA')"
            v-model="form.EsigibilitaIVA"
            name="EsigibilitaIVA"
            @change="$parent.save($event, 'EsigibilitaIVA')"
            :items="selects.EsigibilitaIVAItems"
            @blur="$v.form.EsigibilitaIVA.$touch()"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'EsigibilitaIVA')"               
            background-color="#ff000010"            
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.Art73')"
            v-model="form.Art73"
            name="Art73"
            @change="$parent.save($event, 'Art73')"
            :items="selects.Art73Items"
            @blur="$v.form.Art73.$touch()"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'Art73')"               
            background-color="#ff000010"               
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.CapitaleSociale')"
              name="CapitaleSociale"
              v-model="form.CapitaleSociale"
              prepend-inner-icon="fas fa-euro-sign"
              @blur="$v.form.CapitaleSociale.$touch()"
              reverse
              type="number"
              filled
              outlined
              background-color="#ff000010" 
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'CapitaleSociale')"                              
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.SDI_FiscalID')"
              name="SDI_FiscalID"
              v-model="form.SDI_FiscalID"
              @blur="$v.form.SDI_FiscalID.$touch()"
              filled
              background-color="#ff000010" 
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'SDI_FiscalID')"                 
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.SDI_PEC')"
              name="SDI_PEC"
              v-model="form.SDI_PEC"
              prepend-inner-icon="fas fa-at"
              @blur="$v.form.SDI_PEC.$touch()"
              filled
              background-color="#ff000010" 
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'SDI_PEC')"                              
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.EORI')"
              name="EORI"
              v-model="form.EORI"
              @blur="$v.form.EORI.$touch()"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'EORI')"                              
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-divider></v-divider>
        <v-col md="8" cols="6">
          <v-select
            color="pink"
            :label="$t(page+'.AlboProfessionale')"
            v-model="form.AlboProfessionale"
            name="AlboProfessionale"
            @change="$parent.save($event, 'AlboProfessionale')"
            :items="selects.AlboProfessionaleItems"
            @blur="$v.form.AlboProfessionale.$touch()"
            required
            outlined
            dense
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'AlboProfessionale')"               
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.ProvinciaAlbo')"
            v-model="form.ProvinciaAlbo"
            name="ProvinciaAlbo"
            @change="$parent.save($event, 'ProvinciaAlbo')"
            :items="selects.ProvinciaAlboItems"
            @blur="$v.form.ProvinciaAlbo.$touch()"
            required
            outlined
            dense
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'ProvinciaAlbo')"               
          ></v-select>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.NumeroIscrizioneAlbo')"
              name="NumeroIscrizioneAlbo"
              v-model="form.NumeroIscrizioneAlbo"
              @blur="$v.form.NumeroIscrizioneAlbo.$touch()"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'NumeroIscrizioneAlbo')"                              
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-dialog
            ref="DataIscrizioneAlbo_dialog"
            v-model="DataIscrizioneAlbo_modal"
            :return-value.sync="form.DataIscrizioneAlbo"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.DataIscrizioneAlbo"
                :label="$t(page+'.DataIscrizioneAlbo')"
                name="DataIscrizioneAlbo"
                prepend-inner-icon="fas fa-calendar"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                clearable
                clear-icon="far fa-trash-alt" 
                @click:clear="$parent.save(null,'DataIscrizioneAlbo')"                   
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="form.DataIscrizioneAlbo"
              scrollable
              :locale="user.locale"
              :first-day-of-week="user.fdow||1"
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="DataIscrizioneAlbo_modal = false"
              >
                {{$t(page+'.Cancel')}}
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="DataIscrizioneAlbo_modal=false;$parent.save(form.DataIscrizioneAlbo, 'DataIscrizioneAlbo')"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col md="6" cols="6">
          <v-select
            color="primary"
            :label="$t(page+'.TipoCassa')"
            v-model="form.TipoCassa"
            name="TipoCassa"
            @change="$parent.save($event, 'TipoCassa')"
            :items="selects.TipoCassaItems"
            @blur="$v.form.TipoCassa.$touch()"
            required
            outlined
            dense
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'TipoCassa')"               
          ></v-select>
        </v-col>
        <v-col md="3" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.AliquotaCassa')"
              name="AliquotaCassa"
              v-model="form.AliquotaCassa"
              prepend-inner-icon="fas fa-percent"
              @blur="$v.form.AliquotaCassa.$touch()"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'AliquotaCassa')"                 
              reverse
              type="number"
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="3" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.AliquotaRitenuta')"
              name="AliquotaRitenuta"
              v-model="form.AliquotaRitenuta"
              prepend-inner-icon="fas fa-percent"
              @blur="$v.form.AliquotaRitenuta.$touch()"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'AliquotaRitenuta')"                 
              reverse
              type="number"         
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
</v-card>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableCountries  } from "@/config/countries";
import _ from 'lodash'
const defaultForm = {
  company: "",
  address: "",
  postalcode: "",
  buildingnumber:"",
  city: "",
  stateorprovince: "",
  country: "",
  companyid: "",
  vatnumber: "",
  sdi: "",
  pec:"",
  iban:"",
  swift:""
};

export default {
  props: ['form','selects'],
  mixins: [validationMixin],
  validations: {
    form: {
      company: { required },
      address: { required },
      buildingnumber: { required},
      postalcode: { required, maxLength: maxLength(8) },
      city: { required },
      stateorprovince: { required },
      country: { required },
      companyid: { required },
      vatnumber: { required },
      sdi: { required },
      pec: { required },
      iban: { required }
    },
  },
  validationMessages: {
    form: {
      company: { required: "Choose your favorite animal" },
      address: { required: "Choose your favorite animal" },
      buildingnumber: { required: "enter building name" },
      city: { required: "City is required" },
      stateorprovince: { required: "State is required" },
      country: { required: "Country is required" },
      companyid: { required: "CompanyID is required" },
      vatnumber: { required: "TAX Number is required" },
      sdi: { required: "SDI is required" },
      iban: { required: "IBAN is required" },
      postalcode: {
        required: "PostalCode is required",
        maxLength: "Max 8 characters",
      },
    },
  },
  data() {
    return {
      page: "BossAccount",
      DataIscrizioneAlbo_modal:false,
      READata_modal:false,
      //form: this.$store.state.userdata.user,
      countries: availableCountries,
      snackbar: false,     
      message:'',
      snackbar_color:'success', 
    };
  },
  computed: {
      ...mapGetters(["user"]),
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.resetForm();
      this.$v.$reset();
    },
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>